import { Logo } from "./Logo";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Footer from "./Footer";
import * as React from "react";
import { useCustomTheme } from "../context/ThemeContext";
import { useLocation } from "react-router-dom";

export default function PageWrapper(props) {
  const { themeSettings } = useCustomTheme();
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/admin/dashboard');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 48px)',
        bgcolor: themeSettings?.body_bg || '#ffffff',
      }}
    >
      {/* 2. Contenitore del contenuto principale */}
      {/* flexGrow: 1 dice a questo Box di "crescere" e occupare tutto lo spazio verticale vuoto,
          spingendo il footer verso il basso. */}
      <Box sx={{ flexGrow: 1 }}>
        <Container
          maxWidth="lg"
          sx={{
            py: { xs: 4, sm: 6 } // Esempio: 32px su mobile, 48px su schermi più grandi
          }}>
          <Logo />
          {props.children}
        </Container>
      </Box>

      {/* 3. Footer (nascosto nel pannello di controllo) */}
      {!isDashboard && <Footer />}
    </Box>
  );
}